import { Field, ObjectType } from "type-graphql";
import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, OneToMany, OneToOne, PrimaryGeneratedColumn, UpdateDateColumn } from "typeorm";
import BacklogItem from "./backlog-item";

/** An item in the backlog */
@Entity('backlog-item-category')
@ObjectType()
export default class BacklogItemCategory {
    /** The planning uuid */
    @PrimaryGeneratedColumn('uuid')
    @Field(() => String)
    public uuid: string

    /** The title of the backlog item */
    @Column('varchar')
    @Field(() => String)
    public title: string

    /** The order of items */
    @Column('int')
    @Field(() => Number)
    public order: number

    /** The backlog items */
    @OneToMany(() => BacklogItem, item => item.category, {
        nullable: true
    })
    @Field(() => [BacklogItem], {
        nullable: true
    })
    public items: null | BacklogItem[]

    /** The created at timestamp */
    @CreateDateColumn({
        type: 'timestamp'
    })
    @Field(() => Date)
    public createdAt: Date

    /** The timestamp at which it was updated */
    @UpdateDateColumn({
        type: 'timestamp',
        name: 'updatedAt'
    })
    @Field(() => Date)
    public updatedAt: Date
}